<template>
    <div>
        <div class="row rateTableRow">
            <div class="col-6 col-sm-7 col-md-6 bankColumn">
                <div class="row">
                    <div class="col-12 col-lg-4 col-sm-4">
                        <a :href="!isWp && bankURL" class="bank-image-anchor">
                            <img v-lazy="imageURL" class="rt-logo" :alt="account.bankName"/>
                        </a>
                        <span v-if="ad && ad.pixel">
                            <img width="1" height="1" alt="" v-bind:src="$filters.formatTrackingFilter(ad.pixel)" class="pixel">
                        </span>
                    </div>
                    <div class="col-12 col-sm-8">
                        <div class="bankName">
                            <a :href="!isWp && bankURL">{{account.bankName}}</a>
                        </div>
                        <div class="productName">{{account.productName}}</div>
                        <div class="insurer">{{ $filters.insurerTagFilter(account.insurers) }}</div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-sm-5 col-md apyColumn">
                <table class="apyTable">
                    <tr class="apyPercentRow" v-if="isWp && ad.account.bonusAmount">
                        <td class="apyPercent">${{ad.account.bonusAmount}} </td>
                        <td class="apyText">Signup Bonus</td>
                    </tr>
                    <template v-else>
                        <tr class="apyPercentRow">
                            <td class="apyPercent"><span style="width: 100%;">{{$filters.numberFilter(account.apy, 2)}}%<sup v-html="apyCitation"></sup></span></td>
                        <td class="apyText">
                            <template v-if="account.clickUrl"><apy-label :apyTooltipIconCSSClass="'apyTooltipIconClass'"></apy-label></template>
                            <template v-else>APY</template>
                        </td>
                        </tr>
                        <tr class="apyRow" v-if="showDepositAmountAndEstEarning">
                            <td class="apyLabel">
                                <span class="d-none d-xl-block" style="width: 100%;">Estimated Earnings</span>
                                <span class="d-xl-none d-block" style="width: 100%;">Est. Earnings</span>
                            </td>
                            <td class="apyValue">{{$filters.currencyFilter(account.estimatedEarnings, 0)}}</td>
                        </tr>
                        <tr class="apyRow">
                            <td class="apyLabel">Min to Earn APY</td>
                            <td class="apyValue">{{$filters.currencyFormatFilter(account.minAmount)}}</td>
                        </tr>
                        <tr class="apyRow" v-if="isCdOrIra">
                            <td class="apyLabel">Max to Earn APY</td>
                            <td class="apyValue">{{$filters.currencyFormatFilter(account.maxAmount,250000)}}</td>
                        </tr>
                    </template>
                </table>
            </div>
            <div class="col-12 col-md text-center linkColumn order-sm-1 order-12 mt-sm-3 mt-md-0">
                <div v-if="account.clickUrl && !isExperienceB">
                    <button type="button" class="btn btn-primary" v-on:click.prevent="rtButtonClick" :style="{'background-color': CTAButtonColor}" rel="nofollow">
                        <span v-if="labelCTAButton">{{labelCTAButton}}</span>
                        <span v-else>Learn More</span>
                        &nbsp;
			            <font-awesome-icon :icon="['fas', 'chevron-right']"></font-awesome-icon>
                    </button>
                    <br />
                    <label class="bankWebsiteLabel" v-show="frictionLevel == 'none'">at the {{account.bankName}} website</label>
                </div>
                
                <a href class="viewDetailsLink viewDetailsLink-big" v-if="!isWp" v-bind:class="{'viewDetailsLink-small': account.clickUrl}" v-on:click="setSelectedAccount" data-toggle="modal" data-target="#bankDetailsModal">
                    View Details
                    <font-awesome-icon :icon="['far', 'plus-circle']" class="d-sm-none"></font-awesome-icon>
                </a>
            </div>
            <div class="col-12 order-sm-12" v-if="showAdCopy && account.adCopy">
                <div class="col-sm-10 adCopyDiv offset-sm-2 text-center text-sm-left pl-sm-1 mt-3">
                    <span class="adCopyText" v-html="account.adCopy"></span>
                </div>
            </div>
        </div>
        <hr class="hr-mobile-seperator d-block d-sm-none row">
    </div>
</template>

<script lang="ts">
import Vue, { defineComponent, PropType } from 'vue';
import apyLabel from "../../components/apyLabel.vue";
import { adClickMixin } from "../../mixins/adClickMixin";
import "../../utils/filters";

export default defineComponent({
    components: {
        apyLabel: apyLabel
    },
    mixins:[adClickMixin],
    props: {
        account: Object as PropType<RateTable.Account>,
        ad: Object as PropType<AdPlacement>,
        isWp: Boolean,
        labelCTAButton: String,
        CTAButtonColor: String,
        showDepositAmountAndEstEarning: Boolean,
        showAdCopy: Boolean,
        frictionLevel: String,
        isExperienceB: {
            default: false
        }
    },
    computed: {
        apyCitation: function() :String{
            var citation = "";
            if(this.account.numberOfTiers > 1){
                citation = "*";
            }
            if(this.account.hqRates){
                citation += "&#134;"
            }
            return citation;
        },
        isCdOrIra: function():boolean{
            return this.account.sectionId === 1 || this.account.sectionId === 4
        },
        bankURL: function(): string {
            return `${process.env.VUE_APP_PUBLIC_PATH}/banks/${ this.account.bankUriStem }.html`;
        },
        imageURL: function(): string{
            return `${process.env.VUE_APP_CONTENT_URI}/logos/110x75/${ this.account.bankUriStem }.png`;
        }
    },
    methods: {
        rtButtonClick() : void{
            if(this.frictionLevel == "none"){
                adClickMixin.methods.trackAdLink(this.ad);
            }
            else{
                this.setSelectedAccount();
                (jQuery("#rateTableFrictionModal") as any).modal();
            }
        },
        setSelectedAccount() : void {
            this.$parent.$data.selectedAccount = null;
            this.$parent.$data.selectedAccount = this.account;
            this.$parent.$data.selectedAd = null;
            this.$parent.$data.selectedAd = this.ad;
        }
    }
});
</script>
<style scoped>
.adCopyText{
    font-size: 1rem;
    font-weight: 600;
    font-style: italic;
}
table.apyTable td{
    border: none;
}
.bank-image-anchor{
    border:none;
}
</style>
<style>
.apyTooltipIconClass {position:absolute; margin-left:2px; }
</style>